export const UPDATE_SA_VIEW_NAME = "update_search_analytics_view";
export const UPDATE_SA_VIEW_DESC = `Updates an existing Search Analytics View.

Use when the user asks to edit/rename a Search Analytics view or change saved conditions (filters, date, group-by/order-by).

Input:
- 'id' (required): The View ID to update.
- Optional 'replaceViewSettings': when true, omitted saved filters are reset before the provided values are applied. Use this when the user wants to replace the saved conditions rather than patch a few fields.
- Optional fields to update: name, description, query(+type), queryGroupIDs, url(+type), urlGroupIDs, devices, countries, searchTypes, rawKinds, rawKindsNot, isAnonymousQuery.
- rawDataOrderBy, rawDataGroupBy, dataDate: if omitted, current values are preserved.

Notes:
- Write operation (mutation). Returns updated fields and a 'viewUrl' constructed from the view id.
- For replacing an entire saved filter set, prefer 'replaceViewSettings: true'. Otherwise the mutation behaves like a patch and only touches the provided fields.`;
